interface DayShapesProps {
  onNavigate: (to: string) => void;
}

interface GameEntry {
  slug: string;
  name: string;
  blurb: string;
  ready: boolean;
}

const GAMES: readonly GameEntry[] = [
  {
    slug: "flashcards",
    name: "Identify the day shape",
    blurb:
      "See a daytime shape arrangement, pick the vessel. Drills IRPCS Part C Rules 24–30.",
    ready: true,
  },
];

export function DayShapes({ onNavigate }: DayShapesProps) {
  return (
    <>
      <p className="muted">
        Daytime equivalents of the nav-lights catalogue. A black
        silhouette hoisted in the rigging tells the same story as the
        night-time light arrangement — "I'm not under command", "I'm
        constrained by my draft", "I'm fishing". The full per-vessel
        catalogue lives on the Reference tab; drill identification below.
      </p>

      <h2 style={{ marginTop: 24 }}>Games</h2>
      {GAMES.map((g) => (
        <div key={g.slug} className="card">
          <h3 style={{ marginBottom: 4 }}>{g.name}</h3>
          <p className="small muted" style={{ marginBottom: 12 }}>
            {g.blurb}
          </p>
          <button
            onClick={() => onNavigate(`/play/day-shapes/${g.slug}`)}
            className="secondary"
          >
            Play
          </button>
        </div>
      ))}

      <button className="secondary" onClick={() => onNavigate("/play")}>
        ← Back to Play
      </button>
    </>
  );
}
